/* eslint-disable import/prefer-default-export */

// Mirror states from
// https://github.com/RedHatTraining/ole.labenv2/blob/17e5f078ecd6be73bfe1400ebdb1ae7996c68ef2/ole/labenv2/doc_types/user_lab2.yaml#L74

export enum LabsStatus {
  Running = 'running',
  Stopped = 'stopped',
  Deleted = 'deleted',
  Requested = 'requested',
  Created = 'created',
  Transitioning = 'transitioning',
  Installing = 'installing',
  Error = 'error',
  Failed = 'failed',
  Unknown = 'unknown',
  Unavailable = 'unavailable',
  Shelved = 'shelved',
  Null = 'null',
}

// Mirror user_lab2 doc_type:
// https://github.com/RedHatTraining/ole.labenv2/blob/master/ole/labenv2/doc_types/user_lab2.yaml

export interface StateTransition {
  prev_state: LabsStatus;
  desired_state: LabsStatus;
  when: string; // ISO string
}

export interface UserDisplayAlerts {
  near_shutdown_dismissed?: boolean;
  recently_shutdown_dismissed?: boolean;
}

export interface LabComponent {
  slug: string;
  driver: string;
  lab_account_id: string;
  identifier?: string;
  state?: string;
  context?: Record<string, any>;
  logs?: string[];
}

export interface LabWebApplication {
  title?: string;
  description?: string;
  url: string;
}

export interface UserLab {
  doc_id: string;
  doc_type: 'user_lab2';
  '@timestamp': string;

  // States
  state: LabsStatus;
  desired_state: LabsStatus;
  previous_state: LabsStatus;

  state_transition_log: StateTransition[];

  // Ownership & metadata
  create_time?: string;
  user_uuid?: string;
  username: string;

  subscription_id?: string;
  entitlement_id?: string;
  offering_slug?: string;
  started_by_slug?: string;

  user_display_alerts?: UserDisplayAlerts;

  billing_owner?: string;
  billing_region?: string;

  modality?: 'rhls' | 'vt' | 'alacarte' | 'unknown' | 'rha';
  sub_modality?: string;

  country?: string;
  region?: string;
  availability_zone?: string;

  lab_definition_id?: string;
  lms_order_number?: string;
  osp_vendor?: string;
  origin?: string;

  message?: string;
  stack_trace?: string;

  scheduled_shutdown_time?: string;
  scheduled_destroy_time?: string;

  identifiers?: string[];
  states?: string[];

  components?: LabComponent[];
  web_applications?: LabWebApplication[];

  total_time?: number;

  labels?: Record<string, any>;
  annotations?: Record<string, any>[];
}

export type LabHoursUsedByCourse = {
  offering_slug: string;
  '@timestamp'?: string;
  modality?: string;
  hoursUsed?: number;
  title?: string;
  code?: string;
  version?: string;
};

export type ReporteeLabHoursUsed = {
  username: string;
  offering_slug: string;
  hoursUsed: number;
};

export type LabGradeResults = {
  total: number;
  passed: number;
  graded: number;
};

export type LabGradeStatus = {
  lab_status: 'not_enabled' | 'not_graded' | 'passed' | 'not_passed';
};

// TODO: Extract user_notification from this type and make this an extension of the user_notification type
export type LabPassedNotification = {
  '@timestamp': string;
  archived: boolean;
  content: string;
  course_slug: string;
  deleted: boolean;
  doc_type: string;
  exercise_grade_percentage: number;
  exercise_name: string;
  lab_exercise_type: string;
  lab_title: string;
  notification_type: string;
  page_slug: string;
  source_doc_type: string;
  source_zdoc_id: string;
  title: string;
  user_uuid: string;
  uuid: string;
  view_button: boolean;
};
